const uiKitRoutesNames = {
  charts: 'charts',
  buttons: 'buttons',
  inputs: 'inputs',
  logos: 'logos',
  colors: 'colors',
  typography: 'typography',
  misc: 'misc'
}

const uiKitRoutes = [
  {
    path: 'charts',
    name: uiKitRoutesNames.charts,
    meta: {
      label: 'charts',
      icon: PhRadioButton
    },
    component: () => import('@/views/ui-kit/UIKitCharts.vue')
  },
  {
    path: 'buttons',
    name: uiKitRoutesNames.buttons,
    meta: {
      label: 'Buttons',
      icon: PhRadioButton
    },
    component: () => import('@/views/ui-kit/UIKitButtons.vue')
  },
  {
    path: 'buttons',
    name: uiKitRoutesNames.buttons,
    meta: {
      label: 'Buttons',
      icon: PhRadioButton
    },
    component: () => import('@/views/ui-kit/UIKitButtons.vue')
  },
  {
    path: 'inputs',
    name: uiKitRoutesNames.inputs,
    meta: {
      label: 'Inputs',
      icon: PhArrowSquareRight
    },
    component: () => import('@/views/ui-kit/UIKitInputs.vue')
  },
  {
    path: 'logos',
    name: uiKitRoutesNames.logos,
    meta: {
      label: 'Logos',
      icon: PhFigmaLogo
    },
    component: () => import('@/views/ui-kit/UIKitLogos.vue')
  },
  {
    path: 'colors',
    name: uiKitRoutesNames.colors,
    meta: {
      label: 'Colors',
      icon: PhButterfly
    },
    component: () => import('@/views/ui-kit/UIKitColors.vue')
  },
  {
    path: 'typography',
    name: uiKitRoutesNames.typography,
    meta: {
      label: 'Typography',
      icon: PhReadCvLogo
    },
    component: () => import('@/views/ui-kit/UIKitTypography.vue')
  },
  {
    path: 'misc',
    name: uiKitRoutesNames.misc,
    meta: {
      label: 'Misc',
      icon: PhBoundingBox
    },
    component: () => import('@/views/ui-kit/UIKitMisc.vue')
  }
]

export {
  uiKitRoutesNames,
  uiKitRoutes
}
